import lod_ from "lodash";
import { Card, CardContent, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import MDBox from "components/Basics/MDBox";
import MDTypography from "components/Basics/MDTypography";
import MDInput from "components/Basics/MDInput";
import MDButton from "components/Basics/MDButton";
import { useEffect, useState } from "react";

import formActions from "redux-react/actions/formAction";
import { useDispatch } from "react-redux";
import { t } from "i18next";
import { wsEvent } from "redux-react/actions/ws";
import { socket } from "redux-react/middleware/ws";
import { display } from "redux-react/reducers/snackBarReducer";

/**
 * Main component for models
 * @returns
 */
export default function PromptsPart() {
	const dispatch = useDispatch();

	const [prompts, setPrompts] = useState([]);
	const [selectedPromptCode, setSelectedPromptCode] = useState("");
	const [editedPromptContent, setEditedPromptContent] = useState("");

	const getPrompts = () => {
		dispatch(
			formActions.getItemsFromCollection("promptTemplate", {}, res => {
				setPrompts(res.items || []);
			})
		);
	};

	useEffect(() => {
		getPrompts();
	}, []);

	const handlePromptSelect = code => {
		setSelectedPromptCode(code);
		const selectedPrompt = prompts.find(prompt => prompt.code === code);
		if (selectedPrompt) {
			setEditedPromptContent(selectedPrompt.prompt);
		}
	};

	const handleSave = () => {
		dispatch(
			wsEvent({
				event: "update_prompt_template_content",
				payload: {
					code: selectedPromptCode,
					content: editedPromptContent
				}
			})
		);
	};

	const handleSaveResult = async ({ success, error }) => {
		if (!success) {
			dispatch(
				display({
					type: "error",
					message: error
				})
			);
		} else {
			dispatch(
				display({
					type: "success",
					message: "Prompt mis à jour avec succès"
				})
			);

			getPrompts();
		}
	};

	useEffect(() => {
		socket.on("update_prompt_template_content_result", handleSaveResult);
		return () => {
			socket.off("update_prompt_template_content_result", handleSaveResult);
		};
	}, []);

	return (
		<MDBox mt={3}>
			<MDTypography variant="h3">Prompts</MDTypography>

			<MDBox mt={3}>
				<Card>
					<CardContent>
						<MDBox display="flex" flexDirection="column" gap={3}>
							{/* Prompt Selection */}
							<FormControl fullWidth sx={{ mt: 3 }}>
								<InputLabel id="prompt-select-label">
									Selectionner un prompt (cluster client)
								</InputLabel>
								<Select
									labelId="prompt-select-label"
									value={selectedPromptCode}
									label="Selectionner un prompt (cluster client)"
									onChange={e => handlePromptSelect(e.target.value)}
								>
									{prompts.map(prompt => (
										<MenuItem key={prompt.code} value={prompt.code}>
											{`${prompt.name} - ${prompt.description} (${prompt.code})`}
										</MenuItem>
									))}
								</Select>
							</FormControl>

							{/* Prompt Editor */}
							<MDBox>
								<MDTypography variant="h6">Editer le prompt</MDTypography>
								<MDInput
									disabled={!selectedPromptCode}
									multiline
									rows={6}
									fullWidth
									value={editedPromptContent}
									onChange={e => setEditedPromptContent(e.target.value)}
									placeholder="Prompt ..."
								/>
								<MDBox mt={2} display="flex" justifyContent="flex-end">
									<MDButton
										variant="gradient"
										color="info"
										onClick={handleSave}
										disabled={
											lod_.isEqual(
												editedPromptContent,
												prompts.find(p => p.code === selectedPromptCode)?.prompt
											) || !selectedPromptCode
										}
									>
										{t("SETTINGS.save")}
									</MDButton>
								</MDBox>
							</MDBox>
						</MDBox>
					</CardContent>
				</Card>
			</MDBox>
		</MDBox>
	);
}
